import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
//Componentes material
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import MenuIcon from '@material-ui/icons/Menu';
import Container from '@material-ui/core/Container';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';
//Componentes
import Menu from '../components/Menu';

//Definindo estilos
const styles = (theme) => ({
    titulo: {
        flexGrow: 1
    },
    container: {
        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(9)
        },
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(10)
        },
        marginBottom: theme.spacing(10)
    },
    loader: {
        [theme.breakpoints.down('xs')]: {
            top: theme.spacing(7)
        },
        [theme.breakpoints.up('sm')]: {
            top: theme.spacing(8)
        },
        position: 'sticky'
    }
});

/**
 * Layout padrão da aplicação.
 * Contém um menu lateral, uma barra de aplicação e renderiza os componentes no centro
 */
class Layout extends React.Component {

    constructor(props) {
        super(props);
        //Bindings
        this.handleIconButtonClick = this.handleIconButtonClick.bind(this);
        this.handleDrawerClose = this.handleDrawerClose.bind(this);
        //Estado inicial
        this.state = {
            showMenu: false
        };
    }

    /**
     * Evento disparado quando o botão de menu é pressionado.
     * Exibe o menu lateral
     */
    handleIconButtonClick() {
        this.setState({ showMenu: true });
    }

    /**
     * Evento disparado quando o menu é fechado.
     * Atualiza estado para que o menu não seja exibido
     */
    handleDrawerClose() {
        this.setState({ showMenu: false });
    }

    render() {
        const { showMenu } = this.state;
        const { classes, children, onLogout, carregando, usuario, empresa, permissoes, returnLink, rightButton } = this.props;

        let titulo = 'Vitalize';
        if (empresa && empresa.nome)
            titulo = empresa.nome;

        return (
            <React.Fragment>
                <CssBaseline />
                <AppBar>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" aria-label="menu" onClick={this.handleIconButtonClick} >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.titulo} >
                            { titulo }
                        </Typography>
                        {
                            returnLink && <Button variant="text" color="inherit" component={Link} to={returnLink}>Voltar</Button>
                        }
                        {
                            rightButton
                        }
                    </Toolbar>
                </AppBar>
                { carregando && <LinearProgress className={classes.loader} /> }
                <Container className={classes.container}>
                    { children }
                </Container>
                <Drawer anchor="left" open={showMenu} onClose={this.handleDrawerClose} >
                    <Menu onLogout={onLogout} usuario={usuario} empresa={empresa} permissoes={permissoes} />
                </Drawer>
            </React.Fragment>
        );
    }
}

Layout.propTypes = {
    /** Classes CSS utilizadas pelo componente */
    classes: PropTypes.shape({ container: PropTypes.any, loader: PropTypes.any, titulo: PropTypes.any }),
    /** Componente(s) que serão renderizados no centro do layout */
    children: PropTypes.any,
    /** Callback executado quando o usuário realiza o logout */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired,
    /** Indica se os dados da página estão sendo carregados */
    carregando: PropTypes.bool,
    /** Link para o botão de voltar */
    returnLink: PropTypes.string,
    /** Componente a ser exibido como botão à direita */
    rightButton: PropTypes.any
};

Layout.defaultProps = {
    carregando: false
};

export default withStyles(styles)(Layout);